import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionRefresh"] */ "/vercel/path0/components/SessionRefresh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StytchClientProvider"] */ "/vercel/path0/components/StytchClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertDialogProvider"] */ "/vercel/path0/components/ui/alert-dialog-custom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/vercel/path0/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AIPollingProvider"] */ "/vercel/path0/lib/contexts/AIPollingContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationProvider"] */ "/vercel/path0/lib/contexts/OrganizationContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Libre_Caslon_Text\",\"arguments\":[{\"variable\":\"--font-libre-caslon\",\"weight\":[\"400\",\"700\"],\"subsets\":[\"latin\"]}],\"variableName\":\"libreCaslon\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
